<template>

<div>
  <modal name="investment-modal"
         transition="nice-modal-fade"
         :min-width="200"
         :delay="100"
         :scrollable="true"
         :adaptive="true"
         :resizable="true"
         >
    <i class="fas fa-question-circle help-icon"></i>
    <span v-html="helper_investment"></span>    
  </modal>
  
  
  <modal name="network-modal"
         transition="nice-modal-fade"
         :min-width="200"
         :delay="100"
         :scrollable="true"
         :adaptive="true"
         :resizable="true"
         >
    <i class="fas fa-question-circle help-icon"></i>
    <span v-html="helper_network"></span>    
  </modal>
  
  <modal name="other-costs-modal"
         transition="nice-modal-fade"
         :min-width="200"
         :delay="100"
         :scrollable="true"
         :adaptive="true"
         :resizable="true"
         >
    <i class="fas fa-question-circle help-icon"></i>
    <span v-html="helper_other_costs"></span>    
  </modal>
  
  
  <h2>Investissement</h2>

  <div class="form-label">
    Prix de votre installation&nbsp;:&nbsp;<button aria-label="Aide" class="modal-helper" @click="showModalInvestment"><i class="fas fa-question-circle"></i></button>
    <div class="input-group">
      <input class="text-center" v-model.number="investment_pv_installation" @change="computeData" type="number">
      <span class="input-group-label">
        €
      </span>
    </div>
    <span class="help-text field-error" v-if="error_in_investment_pv_installation">Le format attendu est un nombre positif.</span>
  </div>
  
  <div v-if="price_per_peak_watt_warning_label" :class="price_per_peak_watt_warning_label" class="callout" id="price_warning">
      <span class="comment" v-html="price_per_peak_watt_warning_message"></span>
    </div>

    <h2>Investissement spécifique</h2>

    <div class="investment-specific">
      <div class="grid-x grid-margin-x">
        
        <div class="show-for-medium medium-4 cell"></div>
        <!--<div class="show-for-medium medium-2 cell text-center"><i class="iwb"></i>Vente de la totalité IAB</div>-->
        <div class="show-for-medium medium-2 cell text-center"><i class="overlay"></i>Vente de la totalité sur-imposition</div>
        <div class="show-for-medium medium-2 cell text-center"><i class="surplus_sale"></i>Autoconsommation partielle vente du surplus</div>
        <div class="show-for-medium medium-2 cell text-center"><i class="free_sale"></i>Autoconsommation partielle cession gratuite</div>
        <div class="show-for-medium medium-2 cell text-center"><i class="autoconsumption"></i>Autoconsommation totale</div>

      </div>


      <div class="grid-x grid-margin-x">
        
        <div class="small-12 medium-4 cell">
          <h3 class="show-for-small-only">Raccordement au réseau</h3>
          <span class="show-for-medium">Raccordement au réseau</span>&nbsp;<button aria-label="Aide" class="modal-helper" @click="showModalNetwork"><i class="fas fa-question-circle"></i></button>
        </div>

        <!--
        <div class="small-6 hide-for-medium  hide-for-large cell">Vente de la totalité IAB</div>
        <div class="small-6 medium-2 cell">
          <div class="input-group align-right">
            <input class="text-right" v-model.number="connection_iwb" @change="computeData" type="number">
            <span class="input-group-label">
              €
            </span>
          </div>
          <span class="help-text field-error" v-if="error_in_connection_iwb">Le format attendu est un nombre positif.</span>
        </div>
        -->
        <div class="small-6 hide-for-medium  hide-for-large cell">Vente de la totalité sur-imposition</div>
        <div class="small-6 medium-2 cell">
          <div class="input-group align-right">
            <input class="text-right" v-model.number="connection_overlay" @change="computeData" type="number">
            <span class="input-group-label">
              €
            </span>
          </div>
          <span class="help-text field-error" v-if="error_in_connection_overlay">Le format attendu est un nombre positif.</span>
        </div>

        <div class="small-6 hide-for-medium  hide-for-large cell">Autoconsommation partielle vente du surplus</div>
        <div class="small-6 medium-2 cell">
          <div class="input-group align-right">
            <input class="text-right" v-model.number="connection_surplus_sale" @change="computeData" type="number">
            <span class="input-group-label">
              €
            </span>
          </div>
          <span class="help-text field-error" v-if="error_in_connection_surplus_sale">Le format attendu est un nombre positif.</span>
        </div>

        <div class="small-6 hide-for-medium  hide-for-large cell">Autoconsommation partielle cession gratuite</div>
        <div class="small-6 medium-2 cell">
          <div class="input-group align-right">
            <input class="text-right" v-model.number="connection_free_sale" @change="computeData" type="number">
            <span class="input-group-label">
              €
            </span>
          </div>
          <span class="help-text field-error" v-if="error_in_connection_free_sale">Le format attendu est un nombre positif.</span>
        </div>

        <div class="small-6 hide-for-medium  hide-for-large cell">Autoconsommation totale</div>
        <div class="small-6 medium-2 cell">
          <div class="input-group align-right">
            <input class="text-right" v-model.number="connection_autoconsumption" @change="computeData" type="number">
            <span class="input-group-label">
              €
            </span>
          </div>
          <span class="help-text field-error" v-if="error_in_connection_autoconsumption">Le format attendu est un nombre positif.</span>
        </div>

      </div>

      <div class="grid-x grid-margin-x">
        
        <div class="small-12 medium-4 cell">
          <h3 class="show-for-small-only">Autres frais</h3>
          <span class="show-for-medium">Autres frais</span>&nbsp;<button aria-label="Aide" class="modal-helper" @click="showModalOtherCosts"><i class="fas fa-question-circle"></i></button>
        </div>

        <!--
        <div class="small-6 hide-for-medium  hide-for-large cell">Vente de la totalité IAB</div>
        <div class="small-6 medium-2 cell">
          <div class="input-group align-right">
            <input class="text-right" v-model.number="other_expenses_iwb" @change="computeData" type="number">
            <span class="input-group-label">
              €
            </span>
          </div>
          <span class="help-text field-error" v-if="error_in_other_expenses_iwb">Le format attendu est un nombre positif.</span>
        </div>
        -->
        
        <div class="small-6 hide-for-medium  hide-for-large cell">Vente de la totalité sur-imposition</div>
        <div class="small-6 medium-2 cell">
          <div class="input-group align-right">
            <input class="text-right" v-model.number="other_expenses_overlay" @change="computeData" type="number">
            <span class="input-group-label">
              €
            </span>
          </div>
          <span class="help-text field-error" v-if="error_in_other_expenses_overlay">Le format attendu est un nombre positif.</span>
        </div>

        <div class="small-6 hide-for-medium  hide-for-large cell">Autoconsommation partielle vente du surplus</div>
        <div class="small-6 medium-2 cell">
          <div class="input-group align-right">
            <input class="text-right" v-model.number="other_expenses_surplus_sale" @change="computeData" type="number">
            <span class="input-group-label">
              €
            </span>
          </div>
          <span class="help-text field-error" v-if="error_in_other_expenses_surplus_sale">Le format attendu est un nombre positif.</span>
        </div>

        <div class="small-6 hide-for-medium  hide-for-large cell">Autoconsommation partielle cession gratuite</div>
        <div class="small-6 medium-2 cell">
          <div class="input-group align-right">
            <input class="text-right" v-model.number="other_expenses_free_sale" @change="computeData" type="number">
            <span class="input-group-label">
              €
            </span>
          </div>
          <span class="help-text field-error" v-if="error_in_other_expenses_free_sale">Le format attendu est un nombre positif.</span>
        </div>

        <div class="small-6 hide-for-medium  hide-for-large cell">Autoconsommation totale</div>
        <div class="small-6 medium-2 cell">
          <div class="input-group align-right">
            <input class="text-right" v-model.number="other_expenses_autoconsumption" @change="computeData" type="number">
            <span class="input-group-label">
              €
            </span>
          </div>
          <span class="help-text field-error" v-if="error_in_other_expenses_autoconsumption">Le format attendu est un nombre positif.</span>
        </div>

      </div>


      
      <div class="grid-x grid-margin-x">
        
        <div class="small-12 medium-4 cell">
          <h3 class="show-for-small-only"><strong>Total</strong></h3>
          <span class="show-for-medium"><strong>Total</strong></span>
        </div>

        <!--
        <div class="small-6 hide-for-medium  hide-for-large cell">Vente de la totalité IAB</div>
        <div class="small-6 medium-2 cell text-right">
          <strong class="sum">{{ investment_iwb }}€</strong>
        </div>
        -->

        <div class="small-6 hide-for-medium  hide-for-large cell">Vente de la totalité sur-imposition</div>
        <div class="small-6 medium-2 cell text-right">
          <strong class="sum">{{ investment_overlay }}€</strong>
        </div>

        <div class="small-6 hide-for-medium  hide-for-large cell">Autoconsommation partielle vente du surplus</div>
        <div class="small-6 medium-2 cell text-right">
          <strong class="sum">{{ investment_surplus_sale }}€</strong>
        </div>

        <div class="small-6 hide-for-medium  hide-for-large cell">Autoconsommation partielle cession gratuite</div>
        <div class="small-6 medium-2 cell text-right">
          <strong class="sum">{{ investment_free_sale }}€</strong>
        </div>

        <div class="small-6 hide-for-medium  hide-for-large cell">Autoconsommation totale</div>
        <div class="small-6 medium-2 cell text-right">
          <strong class="sum">{{ investment_autoconsumption }}€</strong>
        </div>

      </div>
      
    </div>

    <div class="error-message" v-if="error_message">{{error_message}}</div>
        
    
    <div class="comment">
      <span v-html="comment"></span>
    </div>

  </div>

</template>


<script>

import apiClient from '@/api';

import Vue from 'vue';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'

function getValue(value) {
    if (value == null || value == '') {
        return 0;
    }
    return parseFloat(value);
}

function isInt(value) {
    var x;
    if (isNaN(value)) {
        return false;
    }
    x = parseFloat(value);
    return (x | 0) === x;
}

function isIntOrZero(value) {
    var state = isInt(value);
    if (!state) {
        return value === null;
    }
    return state;
}

function checkForm(self) {
    if (!isIntOrZero(self.investment_pv_installation) || !isIntOrZero(self.connection_overlay) || !isIntOrZero(self.other_expenses_overlay) || !isIntOrZero(self.connection_surplus_sale) || !isIntOrZero(self.other_expenses_surplus_sale) || !isIntOrZero(self.connection_free_sale) || !isIntOrZero(self.other_expenses_free_sale) || !isIntOrZero(self.connection_autoconsumption) || !isIntOrZero(self.other_expenses_autoconsumption)) {
        self.error_message = "Erreur dans un des champs. Le formulaire ne doit comporter que des chiffres.";
        return false;
    }
    self.error_message = "";
    return true;
}


export default {
    name: 'GetInvestment',
    data () {
        return {
            comment: null,
            helper_investment: "",
            helper_other_costs: "",
            helper_network: "",
            error_message: "",
            price_per_peak_watt_warning_label: "",
            price_per_peak_watt_warning_message: "",
            
            // connection_iwb: null,
            connection_overlay: null,
            connection_surplus_sale: null,
            connection_free_sale: null,
            connection_autoconsumption: null,
            // other_expenses_iwb: null,
            other_expenses_overlay: null,
            other_expenses_surplus_sale: null,
            other_expenses_free_sale: null,
            other_expenses_autoconsumption: null,
            
            debounced_getPricePerPeakWattWarning: null,
        }
    },
    watch: {
        investment_pv_installation: function () { this.call_debounced_getPricePerPeakWattWarning(); this.computeData(); },
        // connection_iwb: function () { this.computeData(); },
        // other_expenses_iwb: function () { this.computeData(); },
        connection_overlay: function () { this.computeData(); },
        other_expenses_overlay: function () { this.computeData(); },
        connection_surplus_sale: function () { this.computeData(); },
        other_expenses_surplus_sale: function () { this.computeData(); },
        connection_free_sale: function () { this.computeData(); },
        other_expenses_free_sale: function () { this.computeData(); },
        connection_autoconsumption: function () { this.computeData(); },
        other_expenses_autoconsumption: function () { this.computeData(); },
    },
    computed: {
            ...mapMutations(
                [
                    'setFormInvestmentOk',
                ],
            ),
            ...mapFields(
                [
                    'power',
                    'investment_pv_installation',
                    
                    // 'investment_iwb',
                    'investment_overlay',
                    'investment_surplus_sale',
                    'investment_free_sale',
                    'investment_autoconsumption',
                ],
            ),
        
        error_in_investment_pv_installation: function() { return !(this.validatePositiveFloat(this.investment_pv_installation)); },
        // error_in_connection_iwb: function() { return !(this.validatePositiveFloat(this.connection_iwb)); },
        error_in_connection_overlay: function() { return !(this.validatePositiveFloat(this.connection_overlay)); },
        error_in_connection_surplus_sale: function() { return !(this.validatePositiveFloat(this.connection_surplus_sale)); },
        error_in_connection_free_sale: function() { return !(this.validatePositiveFloat(this.connection_free_sale)); },
        error_in_connection_autoconsumption: function() { return !(this.validatePositiveFloat(this.connection_autoconsumption)); },
        error_in_other_expenses_iwb: function() { return !(this.validatePositiveFloat(this.other_expenses_iwb)); },
        error_in_other_expenses_overlay: function() { return !(this.validatePositiveFloat(this.other_expenses_overlay)); },
        error_in_other_expenses_surplus_sale: function() { return !(this.validatePositiveFloat(this.other_expenses_surplus_sale)); },
        error_in_other_expenses_free_sale: function() { return !(this.validatePositiveFloat(this.other_expenses_free_sale)); },
        error_in_other_expenses_autoconsumption: function() { return !(this.validatePositiveFloat(this.other_expenses_autoconsumption)); },
    },
    created: function() {
        this.debounced_getPricePerPeakWattWarning = _.debounce(this.getPricePerPeakWattWarning, 700);
    },
    mounted: function() {
        apiClient.genericGet('/eval-rentability/investment/0/')
            .then(
                response => {
                    console.log('Got investment text', response);
                    this.comment = response.comment;
                    this.helper_investment = response.helper_investment;
                    this.helper_network = response.helper_network;
                    this.helper_other_costs = response.helper_other_costs;
                }
            );
    },
    methods: {
        validateForm: function() {
            let valid = !(
                this.error_in_investment_pv_installation
                    || this.error_in_connection_iwb
                    || this.error_in_connection_overlay
                    || this.error_in_connection_surplus_sale
                    || this.error_in_connection_free_sale
                    || this.error_in_connection_autoconsumption
                    || this.error_in_other_expenses_iwb
                    || this.error_in_other_expenses_overlay
                    || this.error_in_other_expenses_surplus_sale
                    || this.error_in_other_expenses_free_sale
                    || this.error_in_other_expenses_autoconsumption
            );
            this.$store.commit('setFormInvestmentOk', valid);
            return valid;
        },
        validatePositiveFloat: function(value) {
            let float_regex = new RegExp('^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$');
            let result = (float_regex.test(value) || value == null);
            return result;
        },
        showModalInvestment: function() {
            this.$modal.show('investment-modal')
        },
        showModalNetwork: function() {
            this.$modal.show('network-modal')
        },
        showModalOtherCosts: function() {
            this.$modal.show('other-costs-modal')
        },
        call_debounced_getPricePerPeakWattWarning: function(obj) {
            if (obj == undefined) {
                obj = this;
            }
            if (obj.debounced_getPricePerPeakWattWarning != null) {
                console.log('debounce price per peak watt warning');
                obj.price_per_peak_watt_warning_label = 'hide';
                obj.price_per_peak_watt_warning_message = '…';
                obj.debounced_getPricePerPeakWattWarning(obj);
            }
        },
        getPricePerPeakWattWarning: function(obj) {
            apiClient.genericPost('/eval-rentability/compute-data/0/price_warning/', 
                {
                    id: 0,
                    investment: obj.investment_pv_installation,
                    power: obj.power,
                }
            ).then(
                response => {
                    console.log('Got price per peak watt warning', response);
                    obj.price_per_peak_watt_warning_label = response.label;
                    obj.price_per_peak_watt_warning_message = response.message;
                }
            );
        },
        computeData: function(val, oldVal) {
            if (this.validateForm()) {
                // this.investment_iwb = getValue(this.investment_pv_installation) + getValue(this.connection_iwb) + getValue(this.other_expenses_iwb);
                this.investment_overlay = getValue(this.investment_pv_installation) + getValue(this.connection_overlay) + getValue(this.other_expenses_overlay);
                this.investment_surplus_sale = getValue(this.investment_pv_installation) + getValue(this.connection_surplus_sale) + getValue(this.other_expenses_surplus_sale);
                this.investment_free_sale = getValue(this.investment_pv_installation) + getValue(this.connection_free_sale) + getValue(this.other_expenses_free_sale);
                this.investment_autoconsumption = getValue(this.investment_pv_installation) + getValue(this.connection_autoconsumption) + getValue(this.other_expenses_autoconsumption);
            }
            else {
                // this.investment_iwb = null;
                this.investment_overlay = null;
                this.investment_surplus_sale = null;
                this.investment_free_sale = null;
                this.investment_autoconsumption = null;
            }
        },
    },    
}

</script>

<style scoped>
  .show-for-medium {
     text-transform: uppercase;
     font-size: 70%;
  }
.callout.alert {
    background-color: #fff;
    color: #E00003;
    font-weight: bold;
    border: 2px solid #E00003;
}
.callout.warning {
    background-color: #fff;
    color: #333;
    font-weight: bold;
    border: 2px solid #ff7e07;
}
.callout.success {
    background-color: #fff;
    color: #008d00;
    font-weight: bold;
    border: 2px solid #008d00;
}
.error-message {
    margin-top: 1rem;
    color: #800;
    font-weight: bold;
}
.comment {
    margin-top: 2rem;
    margin-bottom: 0.5rem;
}
div.investment-specific input {
    width: 6rem;
}
strong.sum {
    margin-right: 44px;
}
i.iwb, i.free_sale, i.autoconsumption, i.overlay, i.surplus_sale {
    color: #888;
    font-size: 2rem;
    margin-right: 4px;
    display: block;
}
i.autoconsumption {
    font-size: 1.6rem;
    line-height: 2rem;
}
#price_warning {
    -moz-animation-name: fadeIn;
    -webkit-animation-name: fadeIn;
    -ms-animation-name: fadeIn;
    animation-name: fadeIn;
    -moz-animation-duration: 1s;
    -webkit-animation-duration: 1s;
    -ms-animation-duration: 1s;
    animation-duration: 1s;
    -moz-animation-timing-function: ease-in-out;
    -webkit-animation-timing-function: ease-in-out;
    -ms-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out;
    -moz-animation-fill-mode: forwards;
    -webkit-animation-fill-mode: forwards;
    -ms-animation-fill-mode: forwards;
    animation-fill-mode: forwards; 
}
#price_warning.hide {
    -moz-animation-name: fadeOut;
    -webkit-animation-name: fadeOut;
    -ms-animation-name: fadeOut;
    animation-name: fadeOut;
}
@-moz-keyframes fadeIn { 0% { opacity: 0; visibility: hidden; } 100% { opacity: 1; visibility: visible; }}
@-webkit-keyframes fadeIn { 0% { opacity: 0; visibility: hidden; } 100% { opacity: 1; visibility: visible; }}
@-ms-keyframes fadeIn { 0% { opacity: 0; visibility: hidden; } 100% { opacity: 1; visibility: visible; }}
@-keyframes fadeIn { 0% { opacity: 0; visibility: hidden; } 100% { opacity: 1; visibility: visible; }}

@-moz-keyframes fadeOut { 0% { opacity: 1; visibility: visible; }  100% { opacity: 0; visibility: hidden; }} 
@-webkit-keyframes fadeOut { 0% { opacity: 1; visibility: visible; }  100% { opacity: 0; visibility: hidden; }} 
@-ms-keyframes fadeOut { 0% { opacity: 1; visibility: visible; } 100% { opacity: 0; visibility: hidden; }} 
@-keyframes fadeOut { 0% { opacity: 1; visibility: visible; } 100% { opacity: 0; visibility: hidden;  }} 

@media only screen and (min-width: 0px) and (max-width: 639px) {
    div.investment-specific input {
        width: 10rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/investment.vue